export class CambioSpread {

    static path = 'cambio_spread/';

    valor: Float32Array;

    constructor() {
    }
  }



// WEBPACK FOOTER //
// ./src/app/configuracion/cambioSpread.model.ts